import React from 'react'
import { Select } from 'components/ui/select'
import type { QuarterSelectorProps } from '../types/financials.types'

const MONTHS = [
	{ value: 1, label: 'January' },
	{ value: 2, label: 'February' },
	{ value: 3, label: 'March' },
	{ value: 4, label: 'April' },
	{ value: 5, label: 'May' },
	{ value: 6, label: 'June' },
	{ value: 7, label: 'July' },
	{ value: 8, label: 'August' },
	{ value: 9, label: 'September' },
	{ value: 10, label: 'October' },
	{ value: 11, label: 'November' },
	{ value: 12, label: 'December' },
]

export const QuarterSelector: React.FC<QuarterSelectorProps> = ({
	quarters,
	selectedQuarterId,
	onQuarterChange,
	fiscalYearStart,
	onFiscalYearStartChange,
}) => {
	return (
		<div className="flex items-center space-x-4">
			<div className="flex items-center space-x-2">
				<label htmlFor="quarter-select" className="text-sm font-medium text-gray-700">
					Start Quarter:
				</label>
				<Select
					id="quarter-select"
					value={selectedQuarterId}
					onChange={e => onQuarterChange(e.target.value)}
				>
					{[...quarters]
						.sort((a, b) => b.order - a.order) // Sort descending (most recent first)
						.map(quarter => (
							<option key={quarter.id} value={quarter.id}>
								{quarter.label}
							</option>
						))}
				</Select>
				{/* <span className="text-sm text-gray-500">showing 5 quarters</span> */}
			</div>

			{/* <div className="flex items-center space-x-2">
				<label htmlFor="fiscal-year-select" className="text-sm font-medium text-gray-700">
					Fiscal Year Start:
				</label>
				<select
					id="fiscal-year-select"
					value={fiscalYearStart}
					onChange={e => onFiscalYearStartChange(parseInt(e.target.value))}
					className="
						block rounded-md border-gray-300 
						px-3 py-1.5 text-sm
						focus:border-blue-500 focus:ring-blue-500
						transition-colors
					"
				>
					{MONTHS.map(month => (
						<option key={month.value} value={month.value}>
							{month.label}
						</option>
					))}
				</select>
			</div> */}
		</div>
	)
}
